import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  AfterViewInit,
} from "@angular/core";
import { PedidoServiceService } from "./services/pedido-service.service";
import Swal from 'sweetalert2';
import { Pedidos } from "../../../entities/Pedidos/Pedidos";
import {
  DxPopupModule,
  DxButtonModule,
  DxTemplateModule,
  DxDateRangeBoxModule,
} from "devextreme-angular";
import notify from "devextreme/ui/notify";
import { Router } from "@angular/router";
import { OrdenesServiceService } from "src/app/shop/services/ordenes-service.service";
import { Product } from "../../../shared/classes/product";
import { AuthServiceService } from "../login/services/auth-service.service";
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs);
@Component({
  selector: "app-pedidos",
  templateUrl: "./pedidos.component.html",
  styleUrls: ["./pedidos.component.scss"],
})
export class PedidosComponent implements OnInit {
  
  public pedidos: any;
  public showFilterRow: boolean;
  public showHeaderFilter: boolean;
  public loadingVisible: boolean = false;
  public positionOf: string;
  public popupVisible: boolean = false;
  public sinCompras: boolean = true;
  public closeButtonOptions: any;
  public usuario;
  public now = new Date();
  public initialValue: [Date, Date] = [
    this.primerDiaDelMes(this.now),
    new Date(this.now.getTime()),
  ];
  public currentValue: [Date, Date] = this.initialValue;

  mesOrden: string;
  fechaOrden: string;
  meses = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Setiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  public mensajeAgrupar: string =
    "Arrastre un encabezado de columna aquí para agrupar por esa columna";
  isDisabled: boolean = true;
  constructor(
    private router: Router,
    private pedidoService: PedidoServiceService,
    private ordenesService: OrdenesServiceService,
    private authService:AuthServiceService,
  ) {
    this.showHeaderFilter = true;
  }

  ngOnInit() {
    this.usuario  = this.authService.getUser(); 
    if(!this.usuario) {      
      this.router.navigateByUrl('/pages/login/inicio');  
    } else {
      this.ordenesService.todasLasOrdenes().subscribe((result) => {
        this.pedidos = result;
        if(Object.entries(result).length === 0) {
          this.sinCompras = true;
        } else {
          this.sinCompras = false;
        }
      });
    }
  }

  
  obtenerPedidos() {
    this.pedidos = [];
    let rangoFechas: string = `fechaInicio=${this.formatearFecha(
      this.primerDiaDelMes(this.now)
    )} 00:00:00.000&fechaFinal=${this.formatearFecha(
      new Date(this.now.getTime())
    )} 23:59:59.000`;

    this.ordenesService.ordenPorFecha(rangoFechas).subscribe((result) => {
      this.pedidos = result;
    });
  }

  cancelarOrden(id: number) {
    // console.log(id);
    
    this.pedidoService.cancelarOrden(id).subscribe((result)=>{
      
      Swal.fire({
        title: 'Tu pedido ha sido cancelado',
        text: 'Lamentamos este inconveniente. Intentaremos comunicarnos contigo para notificarte de la cancelación.',
        icon: 'error',
        confirmButtonText: 'Realizar otro pedido'  // Cambia el texto del botón en este bloque
      }).then((result)=> {
        if(result.isConfirmed) {
          this.router.navigateByUrl('/home/watch');
        }
      });
    })
  }

  primerDiaDelMes(fecha) {
    return new Date(fecha.getFullYear(), fecha.getMonth(), 1);
  }

  formatearFecha(fecha) {
    if (fecha !== null) {
      const anio = fecha.getFullYear();
      const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
      const dia = fecha.getDate().toString().padStart(2, "0");
      return anio + "-" + mes + "-" + dia;
    }
  }

  currentValueChanged({ value: [startDate, endDate] }) {
    this.pedidos = [];
    let rangoFechas: string = `fechaInicio=${this.formatearFecha(
      startDate
    )} 00:00:00.000&fechaFinal=${this.formatearFecha(endDate)} 23:59:59.000`;
    if (startDate && endDate) {
      this.ordenesService.ordenPorFecha(rangoFechas).subscribe((result) => {
        this.pedidos = result;
        // console.log(result);
      });
    }
  }

  getColorStyles(colorCode: number) {
    let colorStyles = {};

    switch (colorCode) {
      case 0:
        colorStyles = {'color': '#01a8fe'};
        break;
      case 1:
        colorStyles = {'color': '#52bb56'};
        break;
      default:
        colorStyles = {'color': 'red'};
        break;
    }

    for (const key in colorStyles) {
      if (colorStyles.hasOwnProperty(key)) {
          colorStyles[key] = colorStyles[key] + ' !important';
      }
    }

    return colorStyles;
  }

  irAEstatus(orden: any) {
    this.router.navigate(["/pages/estatus-orden", orden.idOrden]);
  }

  irAFacturacion(orden: any) {
    this.router.navigate(["/pages/facturacion", orden.idOrden]);
  }

  openCancelModal(orden: any) {
    Swal.fire({
      title: '¿Deseas cancelar el pedido?',
      text: 'Esta acción no se puede deshacer',
      icon: 'error',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.isConfirmed) {
        this.cancelarOrden(orden.idOrden);
      }
    });  }

    cancelarPedido() {

    }
}
